import { getData, postData, convertPageModel, getFileData } from './api-base.service';


export const getcoursewareList = model => {
  let data = convertPageModel(model);
  return postData('/Courseware/GetCoursewareList', data);
};

export const getCourseWeeklyList = (courseId,campusId) => {
  let data = { courseId,campusId };
  return getData('/Courseware/GetCoursewareWeeklyList', data);
};

export const getCoursewareFilesByWeek = (courseId,campusId,week) => {
  let data = { courseId,campusId,week };
  return getData('/Courseware/GetCoursewareFilesByWeek', data);
};

export const getCourseActivations = (courseId, campusId,week) => {
  let data = {courseId: courseId, campusId: campusId, week: week };
  var result = getData('/Courseware/GetCourseActivations', data);
  return result;
}

export const removeCoursewareFiles = (fileIdList) => {
  var result = postData('/Courseware/RemoveCoursewareFiles', fileIdList);
  return result;
}

export const getCourseware = (coursewareId) => {
  let data = { coursewareId: coursewareId };
  return getData('/Courseware/GetCourseware', data);
}

export const getCoursewareFileList = (coursewareId) => {
  let data = { coursewareId : coursewareId };
  return getData('/Courseware/GetCoursewareFileList', data);
}

export const saveCourseware = (data) => {
  let courseActivationId = data.courseActivationId;
  if (!courseActivationId){
    courseActivationId = null;
  }
  let campusId = data.campusId;
  if (campusId== 0){
    campusId = null;
  }
  let model = {
    Id: data.id,
    Week: data.week,
    CourseId: data.courseId,
    CampusId : campusId,
    CourseActivationId : courseActivationId,
    CoursewareFileType : data.coursewareFileType,
    CoursewareManagementType: data.isAcademicAffairsOnly ? 1 : 0,
    FileList: data.fileList
  };
  return postData('/Courseware/SaveCourseware', model);
}

export const downloadCoursewareFile = (fileId) => {
  let data = { fileId: fileId };
  return getFileData('/Courseware/DownloadCoursewareFile', data, true, true, 2);
}

export const getCoursewareFileUrl = (fileId) => {
  let data = { fileId: fileId };
  return getData('/Courseware/GetCoursewareFileUrl', data);
}

export const downloadCourseware = (model) => {
  let data = convertPageModel(model);
  return getFileData('/Courseware/DownloadCourseware', data, false);
}

export const getTotalFilesInfo = (model) => {
  let data = convertPageModel(model);
  return postData('/Courseware/GetTotalFilesInfo', data);
}



// WEBPACK FOOTER //
// ./src/service/courseware.service.js